import React, { useState, useEffect, useRef } from "react";
import styles from "./Home.module.scss";
import classNames from "classnames/bind";
import images from "../../assets";
import { fetchInfo } from '~/layouts/components/contexts/fetchInfo';
import SpeedtestIcon from '../../assets/images/speedtest-icon.svg'; 

const cx = classNames.bind(styles);

const Home = () => {
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [links, setLinks] = useState([]);
    const [speed, setSpeed] = useState([0, 0, 0, 0]);
    const [siteLogo, setSiteLogo] = useState(images.logo);
    const [bettingSite, setBettingSite] = useState(null);

    const progressTimerRef = useRef(null);

    const resetToHome = () => {
        if (progressTimerRef.current) {
            clearInterval(progressTimerRef.current);
            progressTimerRef.current = null;
        }
        setLoading(false);
        setProgress(0);
    };

    // Fix: bấm Back/Forward quay lại không bị kẹt ở màn loading
    useEffect(() => {
        const onPopState = () => resetToHome();
        const onPageShow = (e) => {
            if (e.persisted) resetToHome();
        };

        window.addEventListener("popstate", onPopState);
        window.addEventListener("pageshow", onPageShow);

        return () => {
            window.removeEventListener("popstate", onPopState);
            window.removeEventListener("pageshow", onPageShow);
            if (progressTimerRef.current) clearInterval(progressTimerRef.current);
        };
    }, []);

    useEffect(() => {
        if (links.length > 0) {
            checkSpeed();
        }
        // eslint-disable-next-line
    }, [links]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await fetchInfo();
                if (data && data.status && data.data.site_url) {
                    // Lọc ra chỉ các access_link mà không lấy betting_site
                    const fetchedLinks = Object.entries(data.data.site_url)
                        .filter(([key]) => key.startsWith("access_link_")) // Chỉ lấy key có access_link_
                        .map(([_, value]) => value); // Lấy giá trị (URL)
    
                    setLinks(fetchedLinks);
                    if (data.data.site_url.betting_site) {
                        setBettingSite(data.data.site_url.betting_site);
                    }
                    
                }
                if (data && data.status && data.data.site_logo) {
                    setSiteLogo(data.data.site_logo);
                }
            } catch (error) {
                console.error(error);
            }
        };
    
        fetchData();
    }, []);
   
    const checkSpeed = async () => {
        if (links.length === 0) return;
    
        // Tạo một mảng tốc độ với giá trị mặc định là null (để UI nhận biết link nào chưa đo xong)
        let newSpeed = new Array(links.length).fill(null);
        setSpeed(newSpeed); // Cập nhật UI ban đầu (chưa có tốc độ)
    
        // Lặp qua từng link và đo tốc độ
        links.forEach(async (link, index) => {
            const time = await measureSpeed(link);
            
            // Cập nhật tốc độ ngay khi đo xong
            setSpeed(prevSpeed => {
                const updatedSpeed = [...prevSpeed];
                updatedSpeed[index] = time; // Chỉ cập nhật tốc độ của link đã đo xong
                return updatedSpeed;
            });
        });
    };
    
    
    const measureSpeed = async (url) => {
        const startTime = performance.now();

        try {
            await fetch(url, { method: "HEAD", mode: "no-cors" });
        } catch (error) {}

        return Math.round(performance.now() - startTime);
    };

    const handleRedirect = (url) => {
        resetToHome();
        setLoading(true);

        progressTimerRef.current = setInterval(() => {
            setProgress((old) => {
                if (old >= 100) {
                    if (progressTimerRef.current) {
                        clearInterval(progressTimerRef.current);
                        progressTimerRef.current = null;
                    }
                    window.location.assign(url);
                    return 100;
                }
                return old + 10;
            });
        }, 300);
    };

    return (
        <div className={cx("wrapper")}>
            <div className={cx("container")}>
                <div className={cx("main-logo")}>
                    <img className={cx('header-nav_logo')} src={siteLogo} alt="logo"/>
                </div>
                {!loading && 
                    <>
                    <h1 className={cx("title")}>ĐƯỜNG LINK TRUY CẬP TRANG CHỦ AE6789</h1>
                    <h2 className={cx("title-container")}>
                        Sản Phẩm Đa Dạng - Bảo Mật Hàng Đầu - AE6789 Thương Hiệu Uy Tín
                    </h2>
                    </>
                }
                {!loading && (
                    <div className={cx("actions-1111")}>
                        <a rel="noopener noreferrer" href="https://1.1.1.1/" target="_blank" className={cx("button-1111")} >
                            <img className={cx('btnvpns')} src={images.btnvpns} alt="lbtn-vpnsogo" />
                        </a>
                        <small>Cài đặt 1.1.1.1 để vượt chặn và truy cập&nbsp;
                            <a href={bettingSite} target="_blank" rel="noopener noreferrer" style={{ fontWeight: "bold", textDecoration: "underline" }}>
                                AE6789
                            </a>&nbsp;một cách nhanh nhất
                        </small>
                    </div>
                )}
                {!loading && (
                    <div className={cx("list-link")}>
                        {links.map((link, index) => (
                            <div key={index} className={cx("link-item-container")}>
                                <div className={cx("link-item")}>
                                  <div className={cx("logo-item")}>
                                    <img className={cx('header-nav_logo')} src={siteLogo} alt="logo"/>
                                  </div>
                                  <div className={cx("speed-item")}>
                                        <span className={cx("number")}>
                                          <strong>{speed[index]} Ms</strong>
                                      </span>
                                  </div>
                                  <div className={cx("link")} onClick={() => handleRedirect(link)}>
                                      <span style={{ fontStyle: "italic" }}>
                                          {new URL(link).hostname}
                                      </span>
                                  </div>
                                  <div className={cx("link-btn")} onClick={() => handleRedirect(link)}>
                                      TRUY CẬP
                                  </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
                {!loading && (
                    <div className={cx("actions")}>
                        <div className={cx("reload-button")} onClick={checkSpeed}>
                            <img src={SpeedtestIcon} alt="Speed Icon" className={cx("speed-icon")} />
                            Kiểm tra tốc độ
                        </div>
                    </div>
                )}
                {loading && (
                    <div className={cx("loading-screen")}>
                        <img src={images.loading} alt="Loading" className={cx("loading-img")} />
                        <div className={cx("loading-text-container")}>
                            <p>Bạn đang được chuyển đến trang chủ 
                                <span>AE6789</span>
                            </p>
                            <p> Vui lòng chờ trong giây lát</p>
                        </div>
                        <div className={cx("progress-bar")}>
                            <div className={cx("progress-fill")} style={{ width: `${progress}%` }}>
                                <span className={cx("loading-text")}>{progress}%</span>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default Home;